module.exports = __webpack_public_path__ + "f14e27005a6415837eebc32976741317.png";